import React from "react";
import { motion } from "framer-motion";

export function TextAnimate({ children, animation = "fadeIn", className = "", stagger = 0.1 }) {
  const text = children?.toString() || "";
  const words = text.split(" ");

  const animations = {
    fadeIn: {
      hidden: { opacity: 0, y: 20 },
      visible: { opacity: 1, y: 0 }
    },
    slideUp: {
      hidden: { opacity: 0, y: 50 },
      visible: { opacity: 1, y: 0 }
    },
    typing: {
      hidden: { width: 0 },
      visible: { width: "auto" }
    }
  };

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: stagger
      }
    }
  };

  if (animation === "typing") {
    return (
      <motion.div
        className={`overflow-hidden whitespace-nowrap ${className}`}
        initial="hidden"
        animate="visible"
        variants={animations.typing}
        transition={{ duration: 2, ease: "easeInOut" }}
      >
        {children}
      </motion.div>
    );
  }

  return (
    <motion.div
      className={className}
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {words.map((word, index) => (
        <motion.span
          key={index}
          className="inline-block mr-1"
          variants={animations[animation]}
          transition={{
            duration: 0.6,
            ease: [0.21, 0.47, 0.32, 0.98]
          }}
        >
          {word}
        </motion.span>
      ))}
    </motion.div>
  );
}